// Runs first from src/index.js; bundled (not inline in index.html) so CSP can block inline scripts.
// Clickjacking is blocked by the X-Frame-Options: DENY header from the nginx/Cloudflare hosting (backend team, not this repo).
// Each vendor snippet is isolated in its own try/catch: analytics failing must never stop the app from mounting.

// Hotjar Tracking Code for https://app.makegoodapp.com
try {
  (function (h, o, t, j, a, r) {
    h.hj =
      h.hj ||
      function () {
        (h.hj.q = h.hj.q || []).push(arguments);
      };
    h._hjSettings = { hjid: 3593445, hjsv: 6 };
    a = o.getElementsByTagName("head")[0];
    r = o.createElement("script");
    r.async = 1;
    r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
    a.appendChild(r);
  })(window, document, "https://static.hotjar.com/c/hotjar-", ".js?sv=");
} catch (error) {
  console.error("Hotjar init failed", error);
}

// This will initiate Upscope connection. It's important it is added to all pages, even when the user is not logged in.
try {
  (function (w, u, d) {
    var i = function () {
      i.c(arguments);
    };
    i.q = [];
    i.c = function (args) {
      i.q.push(args);
    };
    var l = function () {
      var s = d.createElement("script");
      s.type = "text/javascript";
      s.async = true;
      s.src = "https://code.upscope.io/NLJFZFRAbE.js";
      var x = d.getElementsByTagName("script")[0];
      x.parentNode.insertBefore(s, x);
    };
    if (typeof u !== "function") {
      w.Upscope = i;
      l();
    }
  })(window, window.Upscope, document);

  window.Upscope("init");
} catch (error) {
  console.error("Upscope init failed", error);
}
